import styled, { css } from 'styled-components';

export interface InputProp {
  width?: boolean;
}

export const SearchInputWrapper = styled.div<InputProp>`
  display: flex;
  align-items: center;
  gap: 15px;
  border: 1px solid color-mix(in oklab, var(--primary-color) 34%, transparent);
  border-radius: 28px;
  padding: 10px 20px;
  justify-content: space-between;

  input[type='text'] {
    border: none;
    background: transparent;
    outline: none;
    color: var(--primary-color);

    ::-webkit-input-placeholder {
      /* WebKit, Blink, Edge */
      color: color-mix(in oklab, var(--primary-color) 34%, transparent);
    }

    :-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: color-mix(in oklab, var(--primary-color) 34%, transparent);
      opacity: 1;
    }

    ::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: color-mix(in oklab, var(--primary-color) 34%, transparent);
      opacity: 1;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: color-mix(in oklab, var(--primary-color) 34%, transparent);
    }

    ::-ms-input-placeholder {
      /* Microsoft Edge */
      color: color-mix(in oklab, var(--primary-color) 34%, transparent);
    }

    ::placeholder {
      // color: rgba(0, 0, 0, 0.34);
      color: color-mix(in oklab, var(--primary-color) 34%, transparent);
    }

    @media (min-width: 800px) {
      min-width: 260px;
    }
  }

  img {
    cursor: pointer;
  }
`;
